export var EModalType;
(function (EModalType) {
    EModalType["Warning"] = "warning";
    EModalType["Error"] = "error";
})(EModalType || (EModalType = {}));
